import React, { memo } from 'react';

export function EmptyDataWrapComponent({
  isLoading,
  children,
  loadingWrap = '-',
  marginRight = 9,
}: {
  isLoading: boolean;
  loadingWrap?: React.ReactNode;
  children: React.ReactNode;
  marginRight?: number;
}): JSX.Element {
  if (isLoading) return <span style={{ marginRight: marginRight }}>{loadingWrap}</span>;
  return <>{children}</>;
}
export const EmptyDataWrap = memo(EmptyDataWrapComponent);
